import { assign } from 'xstate';
import { Context } from '../bookingsMachine';

const enterFilterBookings = assign<Context, any>((ctx, evt) => ({
    ...ctx,
    Offset: 0,
    Total: 0,
    Results: [],
    ...evt.payload,
}));

export default enterFilterBookings;
